module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0054.png.e3293ab4.jpg";